// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"f9d47aa9","1815":"d5c4bf56","3024":"3c83da3b","5589":"3c83da3b"}[chunkId] + ".chunk.css";
};